export class MeasureKind {
  constructor(readonly name: string, readonly unit: string) {}
}
